import { JsonObject } from "json2typescript";
import { NotificationResponseInterface } from "../interfaces/notification-response.interface";
import { NotificationsResponseInterface } from "../interfaces/notifications-response.interface";
import { NotificationResponseModel } from "./notification-response.model";

@JsonObject('NotificationsResponseModel')
export class NotificationsResponseModel implements NotificationsResponseInterface {

    Notifications?: NotificationResponseModel[];

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}
